module.exports = __webpack_public_path__ + "static/Matt-b20e2c76a86d8292d72d7da3a84450d7.jpg";